const LOGIN = 'account/login';
const LOGIN_FAILED = 'account/login_failed';
const PARSE_HASH = 'account/login/parse-hash';
const PARSE_HASH_FAILED = 'account/login/parse-hash-failed';
const PARSE_HASH_SUCCEEDED = 'account/login_success';
const RECOVER_SESSION = 'account/login/recover-session';
const RECOVER_SESSION_FAILED = 'account/login/recover-session-failed';
const ASSERT_SESSION = 'account/login/assert-session';
const ASSERT_SESSION_FAILED = 'account/login/assert-session-failed';
const loginWithPassword = (payload)=>({
        type: LOGIN,
        payload
    })
;
const parseHash = ()=>({
        type: PARSE_HASH
    })
;
const parseHashFailed = (payload)=>({
        type: PARSE_HASH_FAILED,
        payload
    })
;
const parseHashSucceeded = (payload)=>({
        type: PARSE_HASH_SUCCEEDED,
        payload
    })
;
const loginFailed = (error)=>({
        type: LOGIN_FAILED,
        error
    })
;
const recoverSession = ()=>({
        type: RECOVER_SESSION
    })
;
const recoverSessionFailed = (error)=>({
        type: RECOVER_SESSION_FAILED,
        error
    })
;
const assertSession = ()=>({
        type: ASSERT_SESSION
    })
;
const assertSessionFailed = (error)=>({
        type: ASSERT_SESSION_FAILED,
        error
    })
;

export { ASSERT_SESSION, ASSERT_SESSION_FAILED, LOGIN, LOGIN_FAILED, PARSE_HASH, PARSE_HASH_FAILED, PARSE_HASH_SUCCEEDED, RECOVER_SESSION, RECOVER_SESSION_FAILED, assertSession, assertSessionFailed, loginFailed, loginWithPassword, parseHash, parseHashFailed, parseHashSucceeded, recoverSession, recoverSessionFailed };
//# sourceMappingURL=actions.js.map
